<div class="details-card" id="details-card">
  <h3 class="details-title" id="details-title">
    <mat-icon>description</mat-icon>
    {{ filterType ? translate('documents.details_for_type', { type: filterType }) : filterDomain ?
    translate('documents.details_for_domain', { domain: filterDomain }) : translate('documents.details_all') }}
  </h3>

  <mat-accordion *ngIf="!isLoading && groupedDocuments.length > 0" id="details-accordion">
    <mat-expansion-panel *ngFor="let group of groupedDocuments; let groupIdx = index"
      [id]="'details-group-' + groupIdx">
      <mat-expansion-panel-header id="details-group-header-{{groupIdx}}">
        <mat-panel-title id="details-group-title-{{groupIdx}}">
          {{ translate('documents.group_' + group.group) }}
        </mat-panel-title>
        <mat-panel-description id="details-group-count-{{groupIdx}}">
          {{ group.documents.length }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div *ngIf="group.documents.length > 0; else emptyGroup" [id]="'details-group-docs-' + groupIdx">
        <ng-container *ngFor="let doc of group.documents; let docIdx = index">
          <div class="details-doc-row" [id]="'details-doc-row-' + groupIdx + '-' + docIdx" role="row"
            [attr.data-doc-id]="doc.id" [attr.data-group-idx]="groupIdx" [attr.data-doc-idx]="docIdx">
            <div class="row-inner">
              <div class="download-toast-inline" *ngIf="downloadMessageVisible && activeDownloadDocId === doc.id"
                [id]="'download-toast-' + groupIdx + '-' + docIdx">
                {{ downloadMessage }}
              </div>
              <mat-icon class="doc-type-icon" [ngClass]="getIconClass(doc.original_filename)"
                [id]="'doc-icon-' + groupIdx + '-' + docIdx" role="gridcell">{{ getFileIcon(doc.original_filename)
                }}</mat-icon>
              <span class="doc-name" [id]="'doc-name-' + groupIdx + '-' + docIdx" role="gridcell"
                title="{{doc.original_filename}}">
                {{ doc.original_filename }}
                <mat-icon *ngIf="!doc.publicUrl && !doc.id" class="doc-no-url"
                  style="vertical-align: middle; margin-left: 0.5em; color: #e53935;"
                  matTooltip="Sin archivo disponible">block</mat-icon>
              </span>
              <span class="doc-user" [id]="'doc-user-' + groupIdx + '-' + docIdx" role="gridcell">{{ doc.user }}</span>
              <span class="doc-date" [id]="'doc-date-' + groupIdx + '-' + docIdx" role="gridcell">{{ doc.created_at |
                date: 'yyyy/MM/dd HH:mm:ss' }}</span>
              <div class="doc-actions" role="gridcell">
                <button mat-icon-button class="doc-delete-btn" aria-label="Delete document"
                  matTooltip="{{translate('documents.delete_document_tooltip')}}"
                  (click)="deleteRow(doc); $event.stopPropagation()" [id]="'doc-delete-' + groupIdx + '-' + docIdx">
                  <mat-icon color="warn">delete</mat-icon>
                </button>
                <button mat-icon-button class="doc-download-btn" aria-label="Download document"
                  [disabled]="!doc.id" matTooltip="{{ translate('documents.download_document_tooltip') }}"
                  (click)="downloadDocument(doc); $event.stopPropagation()"
                  [id]="'doc-download-' + groupIdx + '-' + docIdx">
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-template #emptyGroup>
        <div class="details-empty-group" id="details-empty-group">{{ translate('documents.no_documents_in_group') }}
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <div *ngIf="isLoading" class="details-loading" id="details-loading">
    <mat-progress-spinner diameter="32" mode="indeterminate" id="details-loading-spinner"></mat-progress-spinner>
    <span id="details-loading-text">{{ translate('documents.loading') }}</span>
  </div>
  <div *ngIf="!isLoading && groupedDocuments.length === 0" class="details-empty-group" id="details-empty-group-none">
    <mat-icon id="details-empty-icon">info</mat-icon> {{ translate('documents.no_documents_found') }}
  </div>

  <!-- Context Menu Overlay -->
  <div *ngIf="contextMenuVisible" class="doc-context-menu" [style.left.px]="contextMenuX" [style.top.px]="contextMenuY"
    (click)="$event.stopPropagation()">
    <div *ngIf="!confirmContext" class="menu-list">
      <button type="button" (click)="beginContextQuestion()">{{ translate('documents.context.ask_only_this') }}</button>
    </div>
    <div *ngIf="confirmContext" class="confirm-block">
      <div class="confirm-text">{{ translate('documents.context.confirm_only_this') }}</div>
      <div class="confirm-actions">
        <button type="button" class="btn-confirm" (click)="confirmContextSelection(true)">{{ translate('common.yes') }}</button>
        <button type="button" class="btn-cancel" (click)="confirmContextSelection(false)">{{ translate('common.no') }}</button>
      </div>
    </div>
  </div>
</div>